import React, { useState, useEffect } from 'react';
import { Snackbar, Alert, SnackbarOrigin } from '@mui/material';
import colors from '../../constants/colors';

interface AlertSnackbarProps {
  open: boolean;
  severity: 'success' | 'info' | 'warning' | 'error';
  message: string;
  onClose: () => void;
  anchorOrigin?: SnackbarOrigin;
  sx?: object;
}

const AlertSnackbar: React.FC<AlertSnackbarProps> = ({
  open,
  severity,
  message,
  onClose,
  anchorOrigin = { vertical: 'top', horizontal: 'right' },
  sx = {},
}) => {
  // Lock props when open to avoid flicker during close animation
  const [lockedSeverity, setLockedSeverity] = useState(severity);
  const [lockedMessage, setLockedMessage] = useState(message);

  useEffect(() => {
    if (open) {
      setLockedSeverity(severity);
      setLockedMessage(message);
    }
  }, [open, severity, message]);

  return (
    <Snackbar
      open={open}
      autoHideDuration={5000} // 5 seconds
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      sx={{
        '&.MuiSnackbar-root': {
          right: '100px',
          top: '90px',
        },
        ...sx,
      }}
    >
      <Alert
        onClose={onClose}
        severity={lockedSeverity}
        variant="filled"
        icon={null}
        sx={{
          // Custom blue for success
          ...(lockedSeverity === 'success' && {
            backgroundColor: colors.blueDark, // blue
            color: colors.white,
          }),
        }}
      >
        {lockedMessage}
      </Alert>
    </Snackbar>
  );
};

export default AlertSnackbar;
